import React, { useState, useEffect } from "react";
import ReactFlowFromMermaid from "./LineageTransformation/ReactFlowFromMermaid";
import heartLoading from "../../../assests/heartLoading.gif";
import axios from "axios";

const LineageTransformationContent = ({ assetName }) => {
  const [loading, setLoading] = useState(false);
  const [mermaidDiagrams, setMermaidDiagrams] = useState(null);
  const [mermaidTypes, setMermaidTypes] = useState(null);
  const [selectedMermaid, setSelectedMermaid] = useState(null);

  useEffect(() => {
    if (assetName) {
      fetchLineageTransformation(assetName);
    }
  }, [assetName]);

  useEffect(() => {
    if (mermaidDiagrams?.length) {
      const mermaidTypes = mermaidDiagrams.map((d) => d.name);
      setMermaidTypes(mermaidTypes);
      setSelectedMermaid(mermaidDiagrams[0]);
    }
  }, [mermaidDiagrams]);

  const fetchLineageTransformation = async (assetName) => {
    try {
      setLoading(true);
      const apiEndpoint = `${process.env.REACT_APP_API_URL}/lineage-transformation?asset_name=${assetName}`;
      const response = await axios.get(apiEndpoint);
      if (response?.data) {
        setMermaidDiagrams(response.data.mermaid_diagrams);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectMermaid = (mermaidName) => {
    setLoading(true);
    // Just to re render with selected mermaid properly
    setTimeout(() => {
      const _selectedMermaid = mermaidDiagrams.find(
        (d) => d.name === mermaidName
      );
      setSelectedMermaid(_selectedMermaid);
      setLoading(false);
    }, 500);
  };

  return (
    <div className="h-[calc(90vh-300px)]">
      {loading ? (
        <div className="flex flex-col items-center justify-center h-full space-y-3">
          <img src={heartLoading} alt="Loading..." className="h-30" />
          <span className="text-gray-700 text-[20px] mt-[15px] text-center">
            Loading lineage transformation...
          </span>
        </div>
      ) : selectedMermaid ? (
        <ReactFlowFromMermaid
          mermaidDiagram={selectedMermaid?.mermaid_diagram || ""}
          summaries={selectedMermaid?.summaries || []}
          selectedMeramaidName={selectedMermaid?.name}
          mermaidTypes={mermaidTypes || []}
          handleSelectMermaid={handleSelectMermaid}
        />
      ) : (
        <div className="flex flex-col items-center justify-center h-full space-y-3">
          <span className="text-gray-700 text-[20px]">
            No resources found!
          </span>
        </div>
      )}
    </div>
  );
};

export default LineageTransformationContent;
